<template>
  <div class="card">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseCard'
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants';

.card {
  background-color: $white;
  border-radius: 1.75rem;
}
</style>
